import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';

import VStack from '@/components/Layout/VStack';

import { TaskDetailHeader } from './-layout/TaskDetailHeader';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail',
)({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <Suspense>
        <TaskDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>
  );
}
